import React from 'react';
import dva from 'dva';
import { Router } from 'dva/router';
import dynamic from 'dva/dynamic';
import createLoading from 'dva-loading';
//import createHistory from 'history/createBrowserHistory';
import createHistory from 'history/createHashHistory';
import request from 'cmn-utils/lib/request';
import store from 'cmn-utils/lib/store';
import createRoutes from '@/routes';
import 'assets/styles/index.less';
import config from './config';
import { LocaleProvider } from 'antd';
import 'moment/locale/zh-cn';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import en_US from 'antd/lib/locale-provider/en_US';


 // 国际化
 var languageType = window.localStorage.languageType;

 //没有选择过语言，则默认为浏览器语言
 if (!languageType) {
   let lang = navigator.language||navigator.userLanguage;//常规浏览器语言和IE浏览器
   lang = lang.substr(0, 2);//截取lang前2位字符
   if(lang === 'zh'){
     languageType = 1;
   }else{
     languageType = 2;
   }
 }
 
 let systemLanguage = zh_CN;
 // 1代表中文 ，2 代表英文
 if(parseInt(languageType) === 2){
   systemLanguage = en_US;
 }
 
 window.systemLanguage = systemLanguage;

// -> 初始化
const app = dva({ history: createHistory() });

// -> 插件
app.use(createLoading());
app.use({ onError: config.exception.global });

// -> 请求
request.config(config.request).headers(_ => ({
  //'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
  'content-type': 'application/json;charset=UTF-8',
  //token: store.getStore('token')
  token: window.sessionStorage.getItem('token') === null?'':window.sessionStorage.getItem('token')
}));

// 使用mock数据
require('./__mocks__');
// -> Developer mock data
// if (process.env.NODE_ENV === 'development') {
//   require('./__mocks__');
// }

// -> loading
dynamic.setDefaultLoadingComponent(() => config.router.loading);

// -> 注册全局模型
app.model(require('./models/global').default);
// -> 初始化路由
app.router(({ history, app }) => (
  <LocaleProvider locale={systemLanguage}>
    <Router history={history}>{createRoutes(app)}</Router>
  </LocaleProvider>
));

// -> Start
app.start('#root');


// WEBPACK FOOTER //
// ./src/index.js